import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

// Dummy data for friends
const friends = [
  {
    name: "Alice",
    lastMessage: "Hey, how are you?",
    lastMessageTime: "15:30",
    image: "https://via.placeholder.com/50",
    unreadMessages: 2
  },
  {
    name: "Bob",
    lastMessage: "See you tomorrow!",
    lastMessageTime: "14:45",
    image: "https://via.placeholder.com/50",
    unreadMessages: 0
  },
  {
    name: "Charlie",
    lastMessage: "Let’s catch up later.",
    lastMessageTime: "13:20",
    image: "https://via.placeholder.com/50",
    unreadMessages: 5
  },
  {
    name: "Diane",
    lastMessage: "Are you coming?",
    lastMessageTime: "10:00",
    image: "https://via.placeholder.com/50",
    unreadMessages: 3
  }
  // Add more friends as needed
];

const FriendsList = ({ setActiveFriend }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredFriends = friends.filter((friend) =>
    friend.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="w-1/4 bg-white p-4 border-r  border-gray-200 h-full overflow-y-auto">
      <h2 className="text-2xl font-bold mb-4">Friends</h2>
      <div className="relative">
        <FaSearch className="absolute left-3 top-3 text-gray-400" />
        <input
          type="text"
          placeholder="Search..."
          className="w-full p-2 pl-10 mb-4 border rounded-lg"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="space-y-4">
        {filteredFriends.map((friend, index) => (
          <div
            key={index}
            className="cursor-pointer p-2 hover:bg-gray-100 rounded-lg flex items-center"
            onClick={() => setActiveFriend(friend)}
          >
            <img
              src={friend.image}
              alt={friend.name}
              className="h-12 w-12 rounded-full mr-4"
            />
            <div className="flex-grow">
              <div className="flex justify-between">
                <h3 className="text-lg font-semibold">{friend.name}</h3>
                {friend.unreadMessages > 0 && (
                  <div className="ml-4 bg-green-500 text-white text-sm h-6 w-6 rounded-full flex items-center justify-center">
                    {friend.unreadMessages}
                  </div>
                )}
              </div>
              <div className="flex justify-between">
                <p className="text-sm text-gray-600 truncate">
                  {friend.lastMessage}
                </p>
                <span className="text-sm text-gray-400">
                  {friend.lastMessageTime}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FriendsList;
